import { ModelInModelTree } from "../../components/cms/model-space/model-space";

export const getModelFromModelTreeInModelSpaceByUUID = (modelTree: ModelInModelTree[], uuid: string): ModelInModelTree | undefined => {
    for (const model of modelTree) {
        if (model.uuid === uuid) return model;

        if (model?.children && model.children.length > 0) {
            const foundedModel = getModelFromModelTreeInModelSpaceByUUID(model.children, uuid);
            if (foundedModel) return foundedModel;
        }
    }

    return undefined;
};